export const productInfos = {
    description: 'A brief description of the good or service being sold.',
    price: 'The unit price. \nA value of |0| indicates that the service is free of charge.',
    taxInclusive:
        "Indicating if the price shown is inclusive of all local taxes or not. \n|YES| if the price includes all taxes, No otherwise.",
    quantity:
        'The quantity of unit that the price refers to. \nThis can be useful to create intermediate measure. For example, to describe price of a 6 hours parking: unit will be HOUR and quantity 6.',
};
